<script setup lang="ts">
import { computed } from 'vue';
import { useAppStore } from '../stores/app';
import { personalInfo, navItems, socialLinks } from '../data/portfolio';

const appStore = useAppStore();

const currentYear = new Date().getFullYear();

const displayName = computed(() => 
  appStore.isZh ? personalInfo.name : personalInfo.nameEn
);

function handleNavClick(href: string) {
  const sectionId = href.replace('#', '');
  appStore.scrollToSection(sectionId);
}
</script>

<template>
  <footer class="footer">
    <div class="footer-bg"></div>
    <div class="container">
      <div class="footer-content">
        <div class="footer-brand">
          <div class="footer-logo">
            <div class="logo-icon">
              <i class="fas fa-fire"></i>
            </div>
            <span class="logo-text">{{ displayName }}</span>
          </div>
          <p class="footer-tagline">
            {{ appStore.isZh ? '魔丸降世，代码由我主宰' : 'Born of chaos, master of code' }}
          </p>
          <div class="footer-social">
            <a
              v-for="link in socialLinks"
              :key="link.name"
              :href="link.url"
              target="_blank"
              rel="noopener noreferrer"
              class="social-link"
              :title="link.name"
            >
              <i :class="['fab', link.icon]"></i>
            </a>
          </div>
        </div>

        <div class="footer-links">
          <h4 class="footer-title">
            {{ appStore.isZh ? '快速导航' : 'Quick Links' }}
          </h4>
          <ul class="link-list">
            <li v-for="item in navItems" :key="item.id">
              <a :href="item.href" @click.prevent="handleNavClick(item.href)">
                {{ appStore.isZh ? item.label : item.labelEn }}
              </a>
            </li>
          </ul>
        </div>

        <div class="footer-links">
          <h4 class="footer-title">
            {{ appStore.isZh ? '外部链接' : 'External Links' }}
          </h4>
          <ul class="link-list">
            <li>
              <a href="https://github.com/ctkqiang" target="_blank" rel="noopener noreferrer">
                <i class="fab fa-github"></i> GitHub
              </a>
            </li>
            <li>
              <a href="https://www.ctkqiang.xin/bug-bounty-journal/" target="_blank" rel="noopener noreferrer">
                <i class="fas fa-bug"></i> {{ appStore.isZh ? '漏洞赏金' : 'Bug Bounty' }}
              </a>
            </li>
            <li>
              <a href="https://nezha-ai.vercel.app/" target="_blank" rel="noopener noreferrer">
                <i class="fas fa-robot"></i> {{ appStore.isZh ? '哪吒AI' : 'NeZha AI' }}
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div class="footer-bottom">
        <div class="copyright">
          <i class="fas fa-copyright"></i>
          {{ currentYear }} {{ displayName }}. 
          {{ appStore.isZh ? '保留所有权利' : 'All rights reserved' }}.
        </div>
        <div class="footer-flame">
          <i class="fas fa-fire"></i>
        </div>
      </div>
    </div>
  </footer>
</template>

<style scoped>
@import '../styles/components/footer.css';
</style>
